// extracted by mini-css-extract-plugin
export var container = "percentsReturnsRedesign-module--container--yYE8r";
export var img = "percentsReturnsRedesign-module--img--NSmR3";
export var secondImage = "percentsReturnsRedesign-module--secondImage--lMvLG";
export var secondSection = "percentsReturnsRedesign-module--secondSection--CVq-d";
export var secondWrap = "percentsReturnsRedesign-module--secondWrap--4B7uw";
export var secongContainer = "percentsReturnsRedesign-module--secongContainer--BPo39";
export var section = "percentsReturnsRedesign-module--section--pavwN";
export var textBlock = "percentsReturnsRedesign-module--textBlock--kKxoI";
export var title = "percentsReturnsRedesign-module--title--AlWCJ";
export var ulCls = "percentsReturnsRedesign-module--ulCls--GS8Qo";
export var wrap = "percentsReturnsRedesign-module--wrap--MLlrP";